import dayjs from 'dayjs'
import {FC} from 'react'

type Props = {
  date?: Date
}

const DateCell: FC<Props> = ({date}) => <>{date ? dayjs(date).format('MMM DD, YYYY') : ''}</>

export {DateCell}
